import { observable, action } from "mobx";

export default class PhotoEditingPhoto {
  /**
   * @property {number|null}
   */
  @observable photoEditingPhotoId = null;

  /**
   * @property {number|null}
   */
  @observable photoEditingImageId = null;

  /**
   * @property {string|null}
   */
  @observable fileName = null;

  /**
   * @property {boolean|null}
   */
  @observable isHdrCapable = null;

  /**
   * @property {date|null}
   */
  @observable exifDts = null;

  /**
   * @property {number|null}
   */
  @observable exifExposureTime = null;

  /**
   * @property {string|null}
   */
  @observable url = null;

  /**
   * @property {string|null}
   */
  @observable thumbnailUrl = null;

  /**
   * @property {number}
   */
  @observable sequence = 0;

  constructor({
    photoEditingPhotoId = null,
    photoEditingImageId = null,
    fileName = null,
    url = null,
    thumbnailUrl = null,
    sequence = 0,
    isHdrCapable = null,
    exifDts,
    exifExposureTime,
  }) {
    this.photoEditingPhotoId = photoEditingPhotoId;
    this.photoEditingImageId = photoEditingImageId;
    this.fileName = fileName;
    this.url = url;
    this.thumbnailUrl = thumbnailUrl;
    this.sequence = sequence;
    this.isHdrCapable = isHdrCapable;
    this.exifDts = exifDts;
    this.exifExposureTime = exifExposureTime ? Number(exifExposureTime) : null;
  }

  @action
  setPhotoEditingImageId(photoEditingImageId) {
    this.photoEditingImageId = photoEditingImageId;
  }

  @action
  setSequence(sequence) {
    this.sequence = sequence;
  }
}
